import { Card, Spinner } from 'components';
import React from 'react';
import { I18n } from 'core';

import { ReactComponent as SmartMeterIcon } from 'assets/icons/SmartMeter.svg';

import { navigate } from 'navigation';
import { Colors } from 'styles';
import { FormatNumberService } from 'services';
import styles from './RegisteredCUPSWidget.module.scss';

interface RegisteredCUPSWidgetPropsI {
  cupsNumber: number;
}

const RegisteredCUPSWidget = (props: RegisteredCUPSWidgetPropsI): JSX.Element => {
  const { cupsNumber } = props;

  const handleClickNavigate = () => {
    navigate('/tecnic/cups');
  };

  return (
    <Card
      title={I18n.t('DashboardPage.RegisteredCUPSWidget.title')}
      body={[
        <div className={styles.root} key={1}>
          <SmartMeterIcon fill={Colors.COLOR_ELECSUMGREEN} height={50} width={50} />
          <span className={styles.value}>
            {cupsNumber >= 0 ? FormatNumberService.formatInteger(`${cupsNumber}`) : <Spinner size={30} />}
          </span>
          <p className={styles.label}>{I18n.t('DashboardPage.RegisteredCUPSWidget.p1')}</p>
          <button className={styles.viewmore_button} type="button" onClick={() => handleClickNavigate()}>
            {I18n.t('viewMore')}
          </button>
        </div>,
      ]}
    />
  );
};

export default React.memo(RegisteredCUPSWidget);
